import { PropsWithChildren, useContext, useEffect, useRef } from "react";
import { AuthContext } from "contexts/Auth";

export type IProps = PropsWithChildren<{
	/**
	 * The component to display when the user has no right
	 */
	onNoRightComponent?: React.ReactNode | undefined;
	/**
	 * The callback to call when the user has not the right
	 */
	onNoRight?: () => Promise<void> | void | undefined;
}>;

export default function HasSubscriptionPlan({ onNoRight, onNoRightComponent, children }: IProps) {
	const { jwtContent } = useContext(AuthContext);
	const userHasSubscriptionPlan = useRef<boolean>(false);

	useEffect(() => {
		if (!userHasSubscriptionPlan.current) onNoRight?.();
	}, [onNoRight]);

	userHasSubscriptionPlan.current = Boolean(jwtContent?.subscriptionPlan);

	if (!userHasSubscriptionPlan.current) return onNoRightComponent;

	return <>{children}</>;
}
